import { authApi } from "./";

const apiUserPrefix = "users";

export const getUsers = async () => {
  const response = await authApi.post(`${apiUserPrefix}/getUsers`, {});
  return response ?? [];
};

export const getStaffUsers = async () => {
  const response = await authApi.post(`${apiUserPrefix}/getStaffUsers`, {});
  // response.data should be [{ userName: "email" }, ...]
  return response.data ?? [];
};

export const importUsers = async (debtorId: string) => {
  const response = await authApi.post(`${apiUserPrefix}/import`, { debtorId });
  return response.data;
};
export const addUser = async (
  username: string,
  role: string,
  userCode: number,
) => {
  const response = await authApi.post(`${apiUserPrefix}/addUser`, {
    username,
    role,
    userCode,
  });
  return response.data;
};

export const changeLockState = async (id: string | number, state: boolean) => {
  const response = await authApi
    .post(`${apiUserPrefix}/changeState`, {
      id,
      state: state ? 1 : 0,
    })
    .then((json) => json);

  return response.data;
};
